/* SEYUN Volu-Lift PDP: offer selector (pack = 1 Stick variant x quantity), unlocked free-gift tiles, real gift cart lines,
   session timer, page-only announcement, sticky CTA, carousels. Isolated: only acts on pages that render [data-svl-offer] or svl sections. */
(() => {
  if (window.__seyunVl) return;
  window.__seyunVl = true;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const H = { 'Content-Type': 'application/json', Accept: 'application/json' };
  const ss = { get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }, set(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} } };

  function selected(offer) { return $('input[type=radio]:checked', offer) || $('input[type=radio]', offer); }

  function apply(offer) {
    const r = selected(offer);
    if (!r) return;
    const idx = Number(r.dataset.idx) || 1;
    $$('.svl-gift', offer).forEach(g => g.classList.toggle('is-locked', idx < (Number(g.dataset.unlock) || 1)));
    $$('[data-svl-id]').forEach(i => { i.value = r.value; });
    $$('[data-svl-qty]').forEach(i => { i.value = r.dataset.qty || 1; });
    const p = $('[data-svl-stick-price]'), c = $('[data-svl-stick-compare]');
    if (p) p.textContent = r.dataset.price || '';
    if (c) c.textContent = r.dataset.compare || '';
  }

  /* Outside USD the pack price = local stick price x qty - the fixed USD discount converted by Shopify at the
     presentment rate (catalog prices are fixed per market); the USD figures typed in the block only fit the US. */
  const GIFT_LOCAL = { GBP: 2099, CAD: 3899, AUD: 3899, NZD: 4799 };
  function localize(offer) {
    const cur = window.Shopify && window.Shopify.currency;
    if (!cur || !cur.active || cur.active === 'USD') return;
    const rate = Number(cur.rate) || 1;
    const fmt = v => new Intl.NumberFormat('en', { style: 'currency', currency: cur.active, currencyDisplay: 'narrowSymbol' }).format(v / 100);
    $$('input[type=radio][data-qty]', offer).forEach(r => {
      const local = Number(r.dataset.qty) * Number(r.dataset.unit) - Math.round(Number(r.dataset.discUsd) * rate);
      r.dataset.price = fmt(local);
      const b = $('.svl-bx-price b', r.closest('label'));
      if (b) b.textContent = fmt(local);
    });
    $$('.svl-gift-v', offer).forEach(v => {
      const n = parseFloat(v.textContent.replace(/[^0-9.]/g, '')) || 0;
      v.textContent = fmt(n > 0 ? (GIFT_LOCAL[cur.active] || Math.round(n * 100 * rate)) : 0);
    });
  }

  function timer(offer) {
    const el = $('[data-svl-timer]', offer);
    if (!el) return;
    const mins = Number(offer.dataset.timer) || 15;
    let end = Number(ss.get('svl-timer-end'));
    if (!end || end < Date.now()) { end = Date.now() + mins * 60000; ss.set('svl-timer-end', String(end)); }
    const pad = n => String(n).padStart(2, '0');
    const tick = () => {
      let left = Math.max(0, Math.round((end - Date.now()) / 1000));
      if (!left) { end = Date.now() + mins * 60000; ss.set('svl-timer-end', String(end)); left = mins * 60; }
      el.textContent = pad(Math.floor(left / 60)) + ' : ' + pad(left % 60);
    };
    tick(); setInterval(tick, 1000);
  }

  function announce(offer) {
    const txt = offer.dataset.announce;
    if (!txt) return;
    const nodes = $$('.sy-announcement-desktop,.sy-announcement-mobile');
    if (!nodes.length) return;
    const pad = n => String(n).padStart(2, '0');
    const render = () => {
      const now = new Date(), mid = new Date(now); mid.setHours(24, 0, 0, 0);
      const s = Math.max(0, Math.floor((mid - now) / 1000));
      const t = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s / 60) % 60) + ':' + pad(s % 60);
      const html = txt.replace('{timer}', '<span class="svl-ann-timer">' + t + '</span>');
      nodes.forEach(n => { if (n.innerHTML !== html) n.innerHTML = html; });
    };
    if (!$('#svl-ann-css')) { const st = document.createElement('style'); st.id = 'svl-ann-css'; st.textContent = '.svl-ann-timer{display:inline-block;background:#fff;color:#111;border-radius:999px;padding:1px 10px;margin-left:6px;font-variant-numeric:tabular-nums;font-weight:700}'; document.head.appendChild(st); }
    render(); setInterval(render, 1000);
  }

  function initOffers() {
    $$('[data-svl-offer]').forEach(offer => {
      if (offer.dataset.ready) return;
      offer.dataset.ready = '1';
      offer.addEventListener('change', () => apply(offer));
      localize(offer); apply(offer); timer(offer); announce(offer);
    });
  }

  async function post(path, body) {
    const r = await fetch(root + path, { method: 'POST', headers: H, body: JSON.stringify(body) });
    let j = {};
    try { j = await r.json(); } catch (e) {}
    if (!r.ok) throw new Error(j.description || j.message || 'Cart error');
    return j;
  }

  async function openDrawer() {
    await new Promise(r => setTimeout(r, 450));
    const d0 = $('#moonbundle-cart-drawer');
    if (d0 && d0.classList.contains('open')) return;
    const trigger = $('a[href$="/cart"][id*="cart-icon"], #cart-icon-bubble, .header__icon--cart, [data-moonbundle-cart-trigger]');
    if (trigger) { trigger.click(); await new Promise(r => setTimeout(r, 500)); }
    const d = $('#moonbundle-cart-drawer');
    if (!(d && d.classList.contains('open')) && !$('cart-drawer.active, cart-drawer[open]')) window.location.assign(root + 'cart');
  }

  async function addToCart(form) {
    const offer = $('[data-svl-offer]');
    const r = offer && selected(offer);
    const id = Number($('[data-svl-id]', form).value);
    const qty = Math.max(1, Number(r && r.dataset.qty) || 1);
    const idx = Number(r && r.dataset.idx) || 1;
    const tag = (offer && offer.dataset.giftTag) || 'volu-lift-offer';
    const items = [];
    String((offer && offer.dataset.gifts) || '').split(',').filter(Boolean).forEach(x => {
      const [gid, unl] = x.split(':');
      if (gid && idx >= (Number(unl) || 1)) items.push({ id: Number(gid), quantity: 1, properties: { _free_gift: tag } });
    });
    items.reverse();
    items.push({ id, quantity: qty }); // added last: Shopify lists the sticks first, gifts below
    const btn = $('[data-svl-atc]', form), err = $('[data-svl-error]');
    if (err) err.hidden = true;
    btn.setAttribute('aria-busy', 'true');
    window.__svlBusy = true;
    try {
      await post('cart/add.js', { items });
      window.dispatchEvent(new CustomEvent('moonbundle-cart-updated', { detail: { caller: 'seyun-vl' } }));
      await openDrawer();
    } catch (e) {
      if (err) { err.textContent = e.message; err.hidden = false; }
    } finally { window.__svlBusy = false; btn.removeAttribute('aria-busy'); }
  }

  document.addEventListener('submit', e => {
    const form = e.target.closest && e.target.closest('.svl-form');
    if (!form) return;
    e.preventDefault(); e.stopImmediatePropagation();
    addToCart(form);
  }, true);

  document.addEventListener('click', e => {
    if (e.target.closest('[data-svl-top]')) { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }
    if (e.target.closest('[data-svl-stick-go]')) { const f = $('.svl-form'); if (f) f.requestSubmit ? f.requestSubmit() : f.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }
    const car = e.target.closest('[data-svl-carousel]');
    if (car) {
      const track = $('[data-svl-track]', car);
      const step = () => { const c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 18 : 300; };
      if (e.target.closest('[data-svl-prev]')) track.scrollBy({ left: -step(), behavior: 'smooth' });
      if (e.target.closest('[data-svl-next]')) track.scrollBy({ left: step(), behavior: 'smooth' });
      const dot = e.target.closest('[data-svl-dots] button');
      if (dot) { const i = $$('button', dot.parentNode).indexOf(dot); const c = track.children[i]; if (c) track.scrollTo({ left: c.offsetLeft - track.offsetLeft, behavior: 'smooth' }); }
    }
  });

  function initDots() {
    $$('[data-svl-carousel]').forEach(car => {
      const track = $('[data-svl-track]', car), dots = $$('[data-svl-dots] button', car);
      if (!track || !dots.length || car.dataset.dots) return;
      car.dataset.dots = '1';
      track.addEventListener('scroll', () => {
        const kids = Array.from(track.children); let best = 0, bd = 1e9;
        kids.forEach((k, i) => { const d = Math.abs(k.offsetLeft - track.offsetLeft - track.scrollLeft); if (d < bd) { bd = d; best = i; } });
        dots.forEach((d, i) => d.classList.toggle('is-active', i === best));
      }, { passive: true });
    });
  }

  async function initRoutine() {
    const sec = $('[data-svl-routine]');
    if (!sec || sec.dataset.ready || !sec.dataset.url) return;
    sec.dataset.ready = '1';
    try {
      const r = await fetch(sec.dataset.url);
      if (!r.ok) return;
      const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      const t = $('[data-svl-rt-track]', doc);
      if (t && t.children.length) $('[data-svl-rt-track]', sec).innerHTML = t.innerHTML;
    } catch (e) {}
  }

  function initSticky() {
    const bar = $('[data-svl-sticky]'), atc = $('[data-svl-atc]');
    if (!bar || !atc || bar.dataset.ready) return;
    bar.dataset.ready = '1';
    new IntersectionObserver(es => { bar.hidden = es[0].isIntersecting || atc.getBoundingClientRect().top > 0; }, { threshold: 0 }).observe(atc);
  }

  function init() { initOffers(); initSticky(); initDots(); initRoutine(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
